export default {
  addFromMenu: "Add from menu",
  somethingWentWrong: "Something went wrong!",
  emptyItems: "Couldn't find any items with the selected criteria!",
  itemSearchTitle: "Item Search",
  itemSearchPlaceholder: "Search for an item",
  itemCategoryTitle: "Item Category",
  itemCategoryPlaceholder: "Choose from categories",
};
